<script>
	import LineChart from "../charts/LineChart.svelte";

	// Bindings
	export let title = undefined;
	export let subtitle = "";
	export let poptext = undefined;
	export let susAll = [];
	export let susLast = {};
	export let viewRespirator = true;
</script>

<div class="graphcard card">
	<!-- HEADER -->
	<div class="graphcard-header">
		<h3 class="graphcard__title">{title}</h3>
		{#if subtitle}
			{#if poptext !== undefined}
				<div class="popover popover-top">
					<p class="graphcard__subtitle pop-text">
						{subtitle} <span class="pop-indicator">...</span>
					</p>
					<div class="popover-container">
						<div class="card">
							<p>{poptext}</p>
						</div>
					</div>
				</div>
			{:else}
				<p class="graphcard__subtitle">{subtitle}</p>
			{/if}
		{:else}
			<div class="graphcard__controllers">
				<div class="chart-labels-group">
					<div class="chart-label">
						<svg class="icon-line">
							<line stroke="#222222" x1="2" y1="8" x2="18" y2="2" />
						</svg>
						<p class="text">Innlagte</p>
					</div>
					{#if viewRespirator}
					<div class="chart-label">
						<svg class="icon-line">
							<line x1="2" y1="8" x2="18" y2="2" />
						</svg>
						<p class="text">På respirator</p>
					</div>
					{/if}
				</div>
			</div>
		{/if}
	</div>

	<!-- BODY -->
	<div class="graphcard-body flex-row">
		{#if susAll.length > 0}
			<LineChart data={susAll} {viewRespirator} />
		{/if}
	</div>
</div>

<style lang="scss">
	.graphcard {
		width: 100%;
		display: flex;
		flex-direction: column;
		min-height: 180px;
		&-header {
			@include desktop {
				min-height: 51px;
			}
		}
		&__title {
			font-size: fontsize("std");
			font-weight: 500;
			margin: 0;
		}

		&__subtitle {
			font-size: fontsize("std");
			font-weight: 400;
			margin: 0;
		}

		&-body {
			display: flex;
			align-items: center;
			flex-direction: column;
			height: 100px;
			margin: auto 0;

			&.flex-row {
				flex-direction: row;
				justify-content: center;
			}
		}

		&-footer {
			display: flex;
			justify-content: center;
		}

		&__group {
			display: flex;
			flex-direction: column;
			align-items: center;
			margin: 0 1rem;
		}

		&__text {
			margin: 0;
			font-weight: 500;
			font-size: fontsize("xl");

			&--trend {
				font-size: fontsize("std");
			}
		}

		&__label {
			margin: 0;
			font-size: fontsize("md");
		}

		&__controllers {
			display: flex;
			margin-bottom: 1.5rem;

			@include desktop {
				flex-direction: row;
				justify-content: space-between;
			}

			.chart-labels-group {
				display: flex;
				margin: 0.3rem 0 0;

				@include desktop {
					margin: 0.3rem 0 0;
					margin-right: 1.5rem;
				}
				.chart-label {
					display: flex;
					align-items: center;

					.text {
						margin: 0;
					}

					.icon {
						height: 10px;
						width: 10px;
						fill: color("red-light-2");
						margin-right: 0.3rem;
					}
					.icon-line {
						height: 10px;
						width: 20px;
						stroke-width: 3px;
						stroke: color("red");
						margin-right: 0.3rem;
					}

					&:not(:first-child) {
						margin-left: 1rem;
					}
				}
			}
		}
	}

	.card {
		&-body {
			display: flex;
			justify-content: center;
		}
	}
</style>
